import type { EntityViewModel, OrganizationState } from '../../types';
import { collectionsById } from '../collections';

export function itemsByType(organization: OrganizationState, entityType: string): { [key: string]: EntityViewModel } {
  switch (entityType) {
    case 'assets':
      return organization.assetsById;
    case 'substances':
      return organization.substancesById;
    case 'employees':
      return organization.employeesById;
    case 'functions':
      return organization.functionsById;
    case 'issues':
      return organization.issuesById;
    case 'partners':
      return organization.partnersById;
    case 'constitutionalDocuments':
      return organization.constitutionalDocumentsById;
    case 'computers':
      return organization.computersById;
    case 'contracts':
      return organization.contractsById;
    case 'competence':
      return organization.competenceById ?? {};
    case 'guidelines':
      return organization.guidelinesById;
    case 'networks':
      return organization.networksById;
    case 'documents':
      return organization.documentsById;
    case 'externalConnections':
      return organization.externalConnectionsById;
    case 'personalDataItems':
      return organization.personalDataItemsById;
    case 'riskAssessments':
      return organization.riskAssessmentsById;
    case 'reports':
      return organization.reportsById;
    case 'contacts':
      return organization.contactsById;
    case 'tasks':
      return organization.tasksById;
    case 'meetings':
      return organization.meetingsById;
    case 'collections':
      return collectionsById();
  }
  throw new Error('Illegal state (E905), entity type: ' + entityType);
}
